var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18,7c0,2.97-2.16,5.43-5,5.91v11.09h-2V12.91c-2.84-.48-5-2.94-5-5.91,0-3.31,2.69-6,6-6s6,2.69,6,6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPin);
export default __webpack_public_path__ + "static/1787897133/media/icon-pin.1456ce4daf37280d77e603b8c2309f13.svg";
export { ForwardRef as ReactComponent };